export const OemThumbMountType = Object.freeze({
  NeverHasOemThumbMount: 'NeverHasOemThumbMount',
  AlwaysHasOemThumbMount: 'AlwaysHasOemThumbMount',
  SometimesHasOemThumbMount: 'SometimesHasOemThumbMount',
  AlwaysHasOemThumbBoltPattern: 'AlwaysHasOemThumbBoltPattern',
  SometimesHasOemThumbBoltPattern: 'SometimesHasOemThumbBoltPattern',
});
